const state = {
  error: null,
  message: null
}

export default state
